import type { Template, TemplateNormalized } from 'apis/templates';
import supportedLanguages from 'app/utils/supportedLanguages';

export function normalizeTemplate(template: Template): TemplateNormalized {
  return {
    ...template,
    translations: Object.keys(template.translations || {}).reduce(
      (tr, locale) => ({
        ...tr,
        [locale]: {
          ...template.translations[locale],
          isEnabled: !template.translations[locale].is_deactivated,
        },
      }),
      {},
    ),
  };
}

export const helpText = `You can use these replacing variables eg. *{{agent_fullname}}* with the actual agent name:

  {{organization_name}}
  {{requester_firstname}}
  {{requester_fullname}}
  {{requester_email}}
  {{agent_firstname}}
  {{agent_fullname}}
  {{conversation_subject}}
  {{csid}}

  _note_: csid is the conversation ID.`;

export const defaultLanguageCode = 'en';
export const languages = supportedLanguages.concat().sort((a, b) => {
  if (a.code === defaultLanguageCode) return -1;
  if (b.code === defaultLanguageCode) return 1;
  return 0;
});
